export default __webpack_public_path__ + "static/media/19.6a1ada26.svg";